import { canNavigate } from '@/plugins/acl/routeProtection'
import { clearSession } from '@/utils/session'
import { getUserData } from '@/utils/userData'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // ? We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    redirect: to => {
      const userData = getUserData()
      const userRole = userData.role || null
      if (userRole === 'admin' || localStorage.getItem('accessToken')) return { name: 'dashboard' }

      return { name: 'auth-login', query: to.query }
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },

  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/NotAuthorized.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/dashboards/',
    name: 'dashboard',
    component: () => import('@/views/dashboards/index.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/order/stok',
    name: 'order-stok',
    component: () => import('@/views/order/list/OrderStok.vue'),
    meta: {
      layout: 'content',
    },
  },

  {
    path: '/order/lens',
    name: 'order-lens',
    component: () => import('@/views/order/list/OrderLens.vue'),
    meta: {
      layout: 'content',
    },
  },

  {
    path: '/order/create',
    name: 'order-create',
    component: () => import('@/views/order/create/OrderCreate.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/extarct',
    name: 'extarct-list',
    component: () => import('@/views/extarct/ExtarctList.vue'),
    meta: {
      layout: 'content',
    },
  },

  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const userData = localStorage.getItem('userData')
  const isLoggedIn = userData && localStorage.getItem('accessToken') && localStorage.getItem('userAbility')

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })
    }
    clearSession()

    return next({ name: 'auth-login' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next('/')
  }

  return next()
})

export default router
